import {
  Accordion,
  Button,
  Flex,
  HStack,
  useDisclosure,
} from "@chakra-ui/react";
import {
  NotificationPreferencesDto,
  useNotificationPreferences,
} from "@ui/application/forms";
import { ResetPreferencesDialog } from "@ui/application/forms/src/notification-preferences/reset-preferences-dialog";
import { PreferenceCategory } from "./preference-category";

export interface NotificationPreferenceFormProps {
  preferences: NotificationPreferencesDto;
  onSubmit: (preferences: NotificationPreferencesDto) => void;

  isLoading: boolean;

  isError: boolean;
  isSuccess: boolean;
}

export const PreferenceForm = (props: NotificationPreferenceFormProps) => {
  const { preferences, onSubmit, isLoading, isError, isSuccess } = props;
  const {
    notificationPreferences,
    handleChange,
    handleSubmit,
    handleSelectAll,
    handleUseDefaultSettings,
  } = useNotificationPreferences(
    preferences,
    onSubmit,
    isLoading,
    isError,
    isSuccess,
  );
  const disclosure = useDisclosure();
  return (
    <Flex direction="column" alignItems={{ base: "center", md: "flex-end" }}>
      <Flex
        as={Accordion}
        direction="column"
        allowMultiple
        defaultIndex={[]}
        width={{ base: "2xs", sm: "xs", md: "2xl", lg: "5xl" }}
        gap="5"
      >
        {notificationPreferences
          .map((a) => ({
            ...a,
            title: a.id === "misc" ? "Miscellaneous" : a.title,
            weight: a.id === "misc" ? 0 : 1,
          }))
          .sort((a, b) => (b.weight > a.weight ? 1 : -1))
          .map((category, idx) => (
            <PreferenceCategory
              key={category.id + idx}
              {...category}
              {...{ handleChange, handleSelectAll }}
            />
          ))}
      </Flex>
      <HStack justifyContent="flex-end" py="6" spacing="4">
        <Button
          colorScheme="red"
          variant="link"
          onClick={() => disclosure.onOpen()}
        >
          Set to Default Preferences
        </Button>
        <Button
          colorScheme="green"
          onClick={() => handleSubmit()}
          isLoading={isLoading}
          disabled={isError}
          loadingText="Saving..."
        >
          {isError ? "Error" : "Save"}
        </Button>
      </HStack>
      <ResetPreferencesDialog
        onReset={handleUseDefaultSettings}
        {...disclosure}
      />
    </Flex>
  );
};
